import { styled } from "styled-components";

export const StyledProfessorSettings = styled.div`
  height: 100%;
`;
